import { RiMoneyDollarCircleLine } from '@remixicon/react';
import { Card, CardContent } from '@components/ui/Card';
import { formatPrice } from '@/utils';

const StatCard = ({ label, value, icon: Icon, iconBg, iconColor }) => (
  <Card className="overflow-hidden !rounded-3xl !border-0 !shadow-none bg-gray-900">
    <CardContent className="p-4">
      <div className="flex justify-between items-center w-full">
        <div className="text-[28px] font-medium">{value}</div>
        <div className={`w-10 h-10 ${iconBg} rounded-full flex items-center justify-center`}>
          <Icon className={`w-5 h-5 ${iconColor}`} />
        </div>
      </div>
      <div className="text-gray-500 text-sm mt-1">{label}</div>
    </CardContent>
  </Card>
);

const FinancialSummaryCards = ({ totalRevenue = 0, totalCommissions = 0 }) => {
  const formatCompact = (amount) => {
    if (amount >= 1000000) return `$${(amount / 1000000).toFixed(1)}M`;
    if (amount >= 1000) return `$${(amount / 1000).toFixed(1)}k`;
    return formatPrice(amount);
  };

  return (
    <div className="grid grid-cols-2 gap-3">
      <StatCard
        label="Total Revenue"
        value={formatCompact(totalRevenue)}
        icon={RiMoneyDollarCircleLine}
        iconBg="bg-blue-50"
        iconColor=" text-blue-600"
      />
      <StatCard
        label="Total Commissions"
        value={formatCompact(totalCommissions)}
        icon={RiMoneyDollarCircleLine}
        iconBg="bg-green-50"
        iconColor="text-green-400"
      />
    </div>
  );
};

export default FinancialSummaryCards;
